import React from "react";
import {connect} from "react-redux";
import Lottie from "react-lottie";

import * as animationData from "../../../../assets/images/animations/pricing-loader.json";

const PricingLoader = (props) => {

  const {featureGroupsLoading} = props;

  if (!featureGroupsLoading) {
    return null
  }

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  // style zIndex:100 - needed to be more than top panel
  return (
    <div className="popup-background-overlay position-fixed flex flex--center"
         style={{zIndex: 100}}>
      <div className="text-center pr-loader">
        <div className="pr-loader__animation">
          <Lottie options={defaultOptions} isClickToPauseDisabled={true}/>
        </div>
        <span className="color-white bold pr-loader__text">
          Please wait while we prepare the selected price list…
        </span>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {loading} = store.projectScopeNew;
  const {presetsReceived} = store.pricingPreset;

  return {
    featureGroupsLoading: loading || !presetsReceived,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PricingLoader)
